import React, { useEffect, useState } from 'react';
import { Table, Button, Form, Select, Modal, message, Switch } from 'antd';
import axiosInstance from '../../axiosInstance';

const { Option } = Select;

const CurrencySettings = () => {
    const [currencies, setCurrencies] = useState([]);
    const [settings, setSettings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();
    const [isModalVisible, setIsModalVisible] = useState(false);

    useEffect(() => {
        fetchCurrencies();
        fetchSettings();
    }, []);

    const fetchCurrencies = async () => {
        try {
            const res = await axiosInstance.get('/currencies');
            setCurrencies(res.data.currencies || []);
        } catch (error) {
            message.error('Failed to load currencies');
        }
    };

    const fetchSettings = async () => {
        try {
            const res = await axiosInstance.get('/currency-shop-settings');
            setSettings(res.data.settings || []);
        } catch (error) {
            message.error('Failed to load settings');
        }
    };

    const handleSubmit = async (values) => {
        setLoading(true);
        try {
            await axiosInstance.post('/currency-shop-settings/store', {
                ...values
            });
            message.success('Setting saved successfully');
            fetchSettings();
            setIsModalVisible(false);
            form.resetFields();
        } catch (error) {
            message.error('Failed to save setting');
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        {
            title: 'Currency',
            dataIndex: ['currency', 'name'],
            key: 'currency',
            render: (_, record) =>
                `${record.currency?.name} (${record.currency?.code})`
        },
        {
            title: 'Default',
            dataIndex: 'is_default',
            key: 'is_default',
            render: (isDefault) =>
                isDefault ? <span style={{ color: 'green' }}>Yes</span> : 'No'
        }
    ];

    return (
        <div>
            <div style={{ textAlign: 'right', marginBottom: 16 }}>
                <Button type="primary" onClick={() => setIsModalVisible(true)}>
                    Add Setting
                </Button>
            </div>

            <Table
                dataSource={settings}
                columns={columns}
                rowKey="id"
                loading={loading}
                pagination={{ pageSize: 50 }}
                scroll={{ x: 'max-content' }}
                style={{ maxWidth: '100%' }}
            />

            <Modal
                title="Add Currency Setting"
                visible={isModalVisible}
                onOk={() => form.submit()}
                onCancel={() => {
                    form.resetFields();
                    setIsModalVisible(false);
                }}
                confirmLoading={loading}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleSubmit}>
                    <Form.Item
                        name="currency_id"
                        label="Currency"
                        rules={[{ required: true, message: 'Please select a currency' }]}
                    >
                        <Select placeholder="Select a currency">
                            {currencies.map((cur) => (
                                <Option key={cur.id} value={cur.id}>
                                    {cur.name} ({cur.code})
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>

                    <Form.Item
                        name="is_default"
                        label="Set as default"
                        valuePropName="checked"
                    >
                        <Switch />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};

export default CurrencySettings;
